import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  LocalPermissions,
  LocalPermissionsListData,
  LocalPermissionsListParams,
} from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { permissionsApiMock } from '@/libs/mocks/handlers/permissions'

const permissionsApiReal = {
  create: async (body: Partial<LocalPermissions>): Promise<Partial<LocalPermissions>> => {
    return await api
      .post<ApiResponse<Partial<LocalPermissions>>>(URLs.Permissions.create(), body)
      .then((response) => response.data.data)
  },
  getByID: async (params: Partial<LocalPermissions>): Promise<Partial<LocalPermissions>> => {
    return await api
      .get<ApiResponse<Partial<LocalPermissions>>>(
        URLs.Permissions.getByID(params.orgID || '', params.permissionID || ''),
      )
      .then((response) => response.data.data)
  },
  list: async (params: LocalPermissionsListParams): Promise<LocalPermissions[]> => {
    const { orgID } = params
    const query = buildQueryParams(params)
    return await api
      .get<ApiResponse<LocalPermissionsListData>>(URLs.Permissions.list(orgID, query))
      .then((response) => response?.data?.data?.permissions || [])
  },
  listAll: async (params: LocalPermissionsListParams): Promise<LocalPermissions[]> => {
    const { orgID } = params
    const all: LocalPermissions[] = []
    let cursor: string | undefined = undefined
    do {
      const query = buildQueryParams({ ...params, cursor })
      const data = await api
        .get<ApiResponse<LocalPermissionsListData>>(URLs.Permissions.list(orgID, query))
        .then((r) => r?.data?.data)
      all.push(...(data?.permissions || []))
      cursor = data?.next
    } while (cursor)
    return all
  },
  update: async (payload: Partial<LocalPermissions>) => {
    return await api
      .patch(URLs.Permissions.byID(payload.permissionID || ''), payload)
      .then((response) => response.data)
  },
  delete: async (payload: Partial<LocalPermissions>) => {
    return await api
      .delete(URLs.Permissions.byID(payload.permissionID || ''))
      .then((response) => response.data)
  },
}

export const permissionsApi: typeof permissionsApiReal = IS_MOCK_MODE
  ? permissionsApiMock
  : permissionsApiReal
